module.exports = __webpack_public_path__ + "static/img/theme2.b38ed723.png";